<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-calendar-to-do`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.718 4c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77V7h16V5.282c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.163-.088.324-.134.77-.134h1.436c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77V7h6a2 2 0 012 2v34a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h6V5.282c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.162-.088.324-.134.77-.134h1.436zM12 11H8v30h32V11h-4v1.718c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77V11H16v1.718c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77V11zm9.064 18.294l11.768-10.963a1 1 0 011.322-.037l.092.087 1.363 1.463a1 1 0 01.036 1.322l-.086.091-13.895 12.945a1 1 0 01-1.3.055l-.091-.082-7.971-8.03a1 1 0 01-.079-1.32l.084-.094 1.42-1.41a1 1 0 011.32-.078l.093.084 5.924 5.967 11.768-10.963-11.768 10.963z"/></svg>
</template>
<script>

export default {
  name: 'IconCalendarToDo',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
